import { useDispatch, useSelector } from 'react-redux'
import { appSelectors, updateInternetStatus } from './app.slice'

export const appHooks = {
  useInternetStatus: () => useSelector(appSelectors.getInternetStatus),
  useAppActions: () => {
    const dispatch = useDispatch()
    return {
      updateInternetStatus: (payload: boolean) => {
        dispatch(updateInternetStatus(payload))
      },
    }
  },
}
